import { render, staticRenderFns } from "./the-slide-in.vue?vue&type=template&id=2b3a3c5c&"
import script from "./the-slide-in.vue?vue&type=script&lang=js&"
export * from "./the-slide-in.vue?vue&type=script&lang=js&"
import style0 from "./the-slide-in.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports